/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { useState, useEffect, useRef } from "react";
import {
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Collapse,
  Nav,
  Button,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  Input
} from "reactstrap";
import axios from "axios";
import { Link, useNavigation } from "react-navi";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import logo from "../../assets/img/robograf.png";
import { updateAttribute } from "../../redux/actions/generalActions";
import { downloadFile } from "../../services/utils";

export function Header() {
  let timeout = 0;

  // previousData is used to hold the last search data
  // this is useful when the user searches for something then clicks away so
  // "data" will be set to null and the search result popover will disappear
  // if the user then decides to click on the search box again the data will be retrieved from
  // previousData and the result will appear
  const [loading, setLoading] = useState(true);
  const [collapsed, setCollapsed] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [data, setData] = useState(null);
  const [previousData, setPreviousData] = useState(null);
  const [machines, setMachines] = useState(null);

  const navigation = useNavigation();

  const dispatch = useDispatch();
  const searchBox = useRef();

  useEffect(() => {
    // getting the machines and sorting them out
    axios.get(`${process.env.REACT_APP_API_URL}machines`).then(response => {
      const data = response.data.sort((a, b) => {
        if (parseInt(a.machineId, 10) <= parseInt(b.machineId, 10)) {
          return -1;
        }
        return 1;
      });
      setMachines(data);
      setLoading(false);
    });
  }, []);

  function handleCatalogDownload(event) {
    event.persist();
    event.preventDefault();
    let toastId;
    const { CancelToken } = axios;
    const source = CancelToken.source();
    axios({
      url: `${process.env.REACT_APP_API_URL}catalogs/marriage`,
      method: "GET",
      responseType: "blob",
      cancelToken: source.token,
      onDownloadProgress: progressEvent => {
        const progress = progressEvent.loaded / progressEvent.total;
        if (progress === 1) {
          toast.done(toastId);
        } else if (!toastId) {
          toastId = toast.info("Download in progress.", {
            progress
          });
        } else if (!toast.isActive(toastId)) {
          source.cancel("User canceled the operation");
        } else {
          toast.update(toastId, { progress });
        }
      }
    }).then(response => {
      toast.success("Download complete.");

      const fileName = `${event.target.name}.pdf`;
      downloadFile(response.data, fileName);
    });
  }

  function toggleNavbar() {
    setCollapsed(!collapsed);
  }

  function logOut() {
    localStorage.removeItem("jwtToken");
    dispatch(updateAttribute({ isAuthenticated: false }));
    navigation.navigate("/login");
  }

  function handleSearch(event) {
    event.persist();
    const currentSearchTerm = event.target.value;
    if (timeout) clearTimeout(timeout);
    setSearchTerm(currentSearchTerm);
    timeout = setTimeout(() => {
      if (searchTerm !== "") {
        axios
          .get(
            `${
              process.env.REACT_APP_API_URL
            }configs?searchterm=${currentSearchTerm}`
          )
          .then(response => {
            // in case nothing was found, response.data will be an empty string
            // in this case data needs to be set to null
            setData(response.data.length === 0 ? null : response.data);
          });
      } else {
        setData(null);
      }
    }, 300);
  }

  const searchResult =
    data !== null
      ? data.map(config => (
          <DropdownItem
            tag={Link}
            href={`/machines/${config.machineId}/configs/${config.eventId}`}
            key={config.eventId}
            className="search-dropdown-item"
          >
            <b>[{config.eventId}]</b> {config.eventName}
          </DropdownItem>
        ))
      : null;

  let machinesMenu;
  if (loading) {
    machinesMenu = (
      <NavLink tag={Link} className="text-dar" href="/">
        Machines
      </NavLink>
    );
  } else {
    machinesMenu = (
      <UncontrolledDropdown nav inNavbar>
        <DropdownToggle nav caret>
          <span className="text-dark">Machines</span>
        </DropdownToggle>
        <DropdownMenu>
          {machines.map((machine, index, machines) => (
            <React.Fragment key={machine.machineId}>
              <DropdownItem
                tag={Link}
                href={`/machines/${machine.machineId}/configs`}
              >
                <b>[{machine.machineId}]</b> {machine.machineName}
              </DropdownItem>
              {/* This  is done to prevent adding a divider to the last element */
              index + 1 === machines.length ? null : <DropdownItem divider />}
            </React.Fragment>
          ))}
        </DropdownMenu>
      </UncontrolledDropdown>
    );
  }

  return (
    <React.Fragment>
      <Navbar fixed="top" expand="sm" color="light" light>
        <NavbarBrand tag={Link} href="/" className="mr-2 pr-auto">
          <img style={{ width: "65px", height: "50px" }} src={logo} />
        </NavbarBrand>
        <NavbarToggler onClick={toggleNavbar} className="mr-2" />
        <Collapse isOpen={!collapsed} navbar>
          <Nav navbar>
            {machinesMenu}
            <NavItem>
              <NavLink className="text-dark" tag={Link} href="/templates">
                Templates
              </NavLink>
            </NavItem>
            <UncontrolledDropdown nav inNavbar>
              <DropdownToggle nav caret>
                <span className="text-dark">Catalogs</span>
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem
                  tag={Button}
                  value="marriage"
                  name="marriage"
                  onClick={handleCatalogDownload}
                >
                  Marriage
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
            <NavItem>
              <NavLink>
                <span
                  style={{
                    textDecoration: "none",
                    color: "dimgray",
                    cursor: "pointer"
                  }}
                  className="text-dark"
                  onClick={logOut}
                >
                  Log out
                </span>
              </NavLink>
            </NavItem>
          </Nav>
          <Dropdown
            isOpen={data !== null}
            inNavbar
            className="col-md-3 col-sm-3"
          >
            <DropdownToggle
              style={{ minWidth: "15em" }}
              tag={Input}
              id="search"
              type="text"
              value={searchTerm}
              placeholder="Search..."
              onChange={handleSearch}
              ref={searchBox}
              // if no timeout is set then nothing will happen if the user clicks on a result
              // in the search results box because the box will disappear before the event
              // is fired
              onBlur={() =>
                setTimeout(() => {
                  setPreviousData(data);
                  setData(null);
                }, 150)
              }
              onFocus={() => setData(previousData)}
            />
            {searchResult ? (
              <DropdownMenu
                style={{ minWidth: "270px" }}
                className="search-dropdown col-md-12 col-sm-12"
              >
                {searchResult}
              </DropdownMenu>
            ) : null}
          </Dropdown>
        </Collapse>
      </Navbar>

      <br />
    </React.Fragment>
  );
}

export default Header;



// WEBPACK FOOTER //
// ./src/views/layout/header.jsx